import {
  Button,
  Text,
  Title3,
  makeStyles,
  tokens,
} from "@fluentui/react-components";
import { ErrorCircle24Regular, ArrowSync24Regular } from "@fluentui/react-icons";

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    padding: "24px",
    gap: "12px",
    textAlign: "center" as const,
  },
  icon: {
    color: tokens.colorPaletteRedForeground1,
    fontSize: "32px",
  },
  message: {
    color: tokens.colorNeutralForeground3,
    maxWidth: "240px",
  },
});

interface ErrorViewProps {
  message: string | null;
  onRetry?: () => void;
}

export function ErrorView({ message, onRetry }: ErrorViewProps) {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <ErrorCircle24Regular className={styles.icon} />
      <Title3>Something went wrong</Title3>
      <Text className={styles.message} size={200}>
        {message || "An unexpected error occurred. Please try again."}
      </Text>
      {onRetry && (
        <Button
          appearance="primary"
          icon={<ArrowSync24Regular />}
          onClick={onRetry}
        >
          Try Again
        </Button>
      )}
    </div>
  );
}
